



























































































































































































































































































































































import moment from 'moment'
import _ from 'lodash'
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AgendaGarantiaMinimaStore from '@/components/RemuneracaoMedica/financeiro/Store/AgendaGarantiaMinimaStore'
import EventBus from '@/plugins/EventBus'
import { MensagensDaApiEnum } from '@/types/_'
import { formatDateOnly, maskMoney, timeout } from '@/utils/common'
import ModalProcedimentosVinculados from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalProcedimentosVinculados.vue'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'

@Component({
  components: {
    ModalProcedimentosVinculados,
  }
})
export default class ViewFinanceiroAgendaMinimaGarantiaPeriodo extends Vue {
  mode: string = 'CREATE'
  searchPrestador: string = ''
  searchProfissional: any = ''
  profissionalName: string = ''
  loadingPrestadorFilter: boolean = false
  loadingProfissionalFilter: boolean = false
  itemAgendaGarantiaMinima: any = {}
  profissionalExecutante: any = {}

  menu: boolean = false
  $refs!: { formItem: any }

  formRules: any = {
    valid: true,
    data: [(v: string) => !!v || 'Campo obrigatório'],
    prestador: [(v: string) => !!v || 'Campo obrigatório'],
    profissionalExecutante: [(v: string) => !!v || 'Campo obrigatório'],
    estabelecimento: [(v: string) => !!v || 'Campo obrigatório'],
    periodo: [(v: string) => !!v || 'Campo obrigatório'],
    valorGarantia: [(v: string) => !!v || 'Campo obrigatório'],
  }

  profissionaisDebounced = _.debounce(param => this.agendaGarantiaStore.getPessoaProfissionalExecutanteAll(param), 500)
  prestadoresDebounced = _.debounce(async (param: string) => {
    await this.agendaGarantiaStore.getAllPrestadoresByHospital({ filtro: param, limite: 20 })
    this.loadingPrestadorFilter = false
  }, 700)

  loadEditarFeriado: string = ''
  searchLocalExecucao: string = ''
  loadingLocal: boolean = false

  debounce = _.debounce(input => this.agendaGarantiaStore.getLocaisExecucao({ nomeLocalExecucao: input }), 600)

  get loadingEditar() { return this.loadEditarFeriado }
  set loadingEditar(value: string) { this.loadEditarFeriado = value }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDeleteFeriado: boolean = false
  get loadingDelete() { return this.loadDeleteFeriado }
  set loadingDelete(value: boolean) { this.loadDeleteFeriado = value }

  loadVisualizarProcedimentosVinculados: string = ''
  get loadingVisualizarProcedimentosVinculados() { return this.loadVisualizarProcedimentosVinculados }
  set loadingVisualizarProcedimentosVinculados(value: string) { this.loadVisualizarProcedimentosVinculados = value }

  loadCreateOrUpdate: boolean = false
  get loadingCreateOrUpdate() { return this.loadCreateOrUpdate }
  set loadingCreateOrUpdate(value: boolean) { this.loadCreateOrUpdate = value }

  get showModal() { return this.agendaGarantiaStore.modalItemAgendaGarantiaMinima }
  set showModal(value: boolean) { this.agendaGarantiaStore.setModal(value) }

  get itemToDeleteId() { return this.agendaGarantiaStore.itemToDeleteId }
  set itemToDeleteId(value: string) { this.agendaGarantiaStore.setItemToDeleteId(value) }

  modalDeleteItem: boolean = false
  get showModalDeleteItem() { return this.modalDeleteItem }
  set showModalDeleteItem(value: boolean) { this.modalDeleteItem = value }

  get agendaGarantiaStore() {
    return getModule(AgendaGarantiaMinimaStore, this.$store)
  }

  get drawer() {
    return this.agendaGarantiaStore.agendaGarantiaMinimaDrawer
  }

  set drawer(value: boolean) {
    this.agendaGarantiaStore.setAgendaGarantiaMinimaDrawer(value)
  }

  get regrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get headers() {
    return [
      { text: 'Estabelecimento', value: 'nomeEstabelecimento', align: 'center', sortable: false },
      { text: 'Local de execução', value: 'nomeLocalExecucao', align: 'center', sortable: false },
      { text: 'Prestador', value: 'prestadorNome', align: 'center', sortable: false },
      { text: 'Profissional', value: 'profissionalExecutanteNome', align: 'center', sortable: false },
      { text: 'Data', value: 'dataGarantia', align: 'center', sortable: false },
      { text: 'Turno', value: 'periodo', align: 'center', sortable: false },
      { text: 'Valor', value: 'valorGarantia', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get items() {
    return this.agendaGarantiaStore.agendaGarantiaMinimaList
  }

  
  get locaisExecucaoList() {
    return this.agendaGarantiaStore.localExecucaoList
  }


  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  clearAdvancedFilters() {
    this.agendaGarantiaStore.clearFiltroAvançado()
    this.agendaGarantiaStore.setFilterOn(false)
    this.getAllItems()
  }

  formatDate(date: any) {
    return formatDateOnly(date)
  }

  formatMoney(value: any) {
    return maskMoney(value)
  }

  async criarItem() {
    this.mode = 'CREATE'
    this.agendaGarantiaStore.clearItemAgenda()
    this.agendaGarantiaStore.setModal(true)
  }

  async editar(item: any) {
    this.loadingEditar = item.id
    this.mode = 'EDIT'
    this.agendaGarantiaStore.clearItemAgenda()
    this.itemAgendaGarantiaMinima = item
    await timeout(500)
    await this.agendaGarantiaStore.getAgendaGarantiaMinimaPeriodoById(item.id)

    this.agendaGarantiaStore.setLocalExecucaoList([...this.locaisExecucaoList, {
      localExecucaoId: this.agendaGarantiaStore.itemAgendaGarantiaMinima.localExecucaoId,
      nomeLocalExecucao: this.agendaGarantiaStore.itemAgendaGarantiaMinima.nomeLocalExecucao
    }])
    this.agendaGarantiaStore.setModal(true)
    this.loadingEditar = ''
  }

  async apagar() {
    this.loadingDelete = true
    const response = await this.agendaGarantiaStore.deleteItemAgendaGarantiaMinima()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Item apagado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      this.showModalDeleteItem = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDelete = false
  }

  setItemToDelete(id: string) {
    this.itemToDeleteId = id
    this.showModalDeleteItem = !this.showModalDeleteItem
  }

  async visualizarProcedimentosVinculados(item: any) {
    this.loadingVisualizarProcedimentosVinculados = item.id
    this.regrasDeCalculoStore.setModal({ name: 'procedimentosVinculados', value: true })
    this.regrasDeCalculoStore.setAgendaGarantiaMinimaId(item.id)
    await this.regrasDeCalculoStore.getAllProcedimentosVinculados()
    this.loadingVisualizarProcedimentosVinculados = ''
  }

  async getAllItems() {
    this.loadingDataTable = true
    this.getPagina = 1
    await this.agendaGarantiaStore.getAllItemsAgendaGarantiaMinima()
    this.loadingDataTable = false
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.agendaGarantiaStore.clearAgendaMinimaList()
    this.agendaGarantiaStore.clearItemAgenda()

    const vazio = [
      this.agendaGarantiaStore.periodosList,
      this.agendaGarantiaStore.fontesPagadorasList,
      this.agendaGarantiaStore.pessoaProfissionalExecutanteList,
      this.agendaGarantiaStore.prestadoresList,
      this.agendaGarantiaStore.localExecucaoList
    ].some(list => list.length === 0)

    if (vazio) {
      await Promise.all([
        this.agendaGarantiaStore.getPeriodos(),
        this.agendaGarantiaStore.getFontesPagadoras(),
        this.agendaGarantiaStore.getLocaisExecucao()
      ])
    }
    
    await this.getAllItems()
    EventBus.$emit('clearLoadingRequest')
  }

  async fetchLocaisExecucao(clearFilter?: boolean) {
    if(clearFilter) {
      this.searchLocalExecucao = ''
    }
    
    this.loadingLocal = true
    this.$forceUpdate()
    await this.debounce(this.searchLocalExecucao);
    this.loadingLocal = false
  }

  async mounted() {
    await this.init()
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.agendaGarantiaStore.total / this.agendaGarantiaStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.agendaGarantiaStore.pagina
  }

  set getPagina(value: number) {
    this.agendaGarantiaStore.setAgendaGarantiaMinimaPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.agendaGarantiaStore.getAllItemsAgendaGarantiaMinima()
    this.loadingDataTable = false
  }

  /**
   * End Paginação
   */

  @Watch('showModalDeleteItem')
  onChangeShowModalDeleteItem(value) {
    if (!value) this.itemToDeleteId = ''
  }

  get prestadorList() {
    return this.agendaGarantiaStore.prestadoresList
  }

  set prestadorList(value: any) {
    this.agendaGarantiaStore.setPrestadoresList(value)
  }

  get profissionaisList() {
    return this.agendaGarantiaStore.pessoaProfissionalExecutanteList
  }

  get fontePagadorasList() {
    return this.agendaGarantiaStore.fontesPagadorasList
  }

  get periodosList() {
    return this.agendaGarantiaStore.periodosList
  }

  get formattedDate() {
    const date = this.agendaGarantiaStore.itemAgendaGarantiaMinima.dataGarantia
    return date ? this.formatDateForDisplay(date) : ''
  }

  set formattedDate(value: string) {
    this.agendaGarantiaStore.itemAgendaGarantiaMinima.dataGarantia = this.formatDateForApi(value)
  }

  get localExecucaoList() {
    return this.agendaGarantiaStore.localExecucaoList
  }

  formatDateForDisplay(date: string) {
    try {
      const parsedDate = this.parseDate(date)
      const day = String(parsedDate.getDate()).padStart(2, '0')
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
      const year = parsedDate.getFullYear()
      return `${day}/${month}/${year}`
    } catch (error) {
      console.error('Erro ao formatar a data para exibição:', error)
      return ''
    }
  }

  formatDateForApi(date: string) {
    try {
      const [day, month, year] = date.split('-')
      if (!day || !month || !year) throw new Error('Data no formato inválido')

      const formattedDate = new Date(`${year}-${month}-${day}T00:00:00Z`)
      if (formattedDate.toString() === 'Invalid Date') {
        throw new Error('Data inválida')
      }

      return formattedDate.toISOString().split('T')[0]
    } catch (error) {
      console.error('Erro ao formatar a data para a API:', error)
      return ''
    }
  }

  parseDate(date: string) {
    if (date.includes('T')) {
      return new Date(date)
    }
    const [year, month, day] = date.split('-').map(Number)
    return new Date(year, month - 1, day)
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  async createOrUpdateItemFeriado() {
    this.loadingCreateOrUpdate = true

    if (this.$refs.formItem.validate()) {
      const request = this.mode === 'CREATE'
        ? await this.agendaGarantiaStore.createItemAgendaGarantiaMinimaPeriodo()
        : await this.agendaGarantiaStore.updateItemAgendaGarantiaMinimaPeriodo()

      if (request.success) {
        if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD && this.mode === 'EDIT') {
          EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
          this.showModal = false
          this.loadingCreateOrUpdate = false
          return
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Item de feriado ${this.mode === 'CREATE' ? 'criado' : 'atualizado'} com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.getAllItems()
        this.showModal = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingCreateOrUpdate = false
  }
  
  changeProfissionalExecutante(value: any) {
    if (value) {
      this.profissionalName = value.nome
      this.profissionalExecutante = value
      this.agendaGarantiaStore.itemAgendaGarantiaMinima.profissionalExecutanteId = value.userId
    } else {
      this.profissionalName = ''
    }
  }

  @Watch('searchPrestador')
  async onSearchPrestadorChanged(val: string) {
    if (!val || val.length < 3) {
      this.agendaGarantiaStore.setPrestadoresList([])
      return
    }

    this.loadingPrestadorFilter = true
    if (this.prestadoresDebounced) await this.prestadoresDebounced(val)
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      return
    }
    
    if(this.profissionalName === val){
      return
    }
    
    this.loadingProfissionalFilter = true
    
    await this.profissionaisDebounced(val)
  }

  @Watch('showModal')
  async onChangeShowModal(value) {
    if (!value) {
      this.agendaGarantiaStore.clearItemAgenda()
      this.agendaGarantiaStore.itemAgendaGarantiaMinima.periodo.key = ''
      this.$refs.formItem.resetValidation()
      this.agendaGarantiaStore.setPessoaProfissionalExecutanteList([])
      this.agendaGarantiaStore.setPrestadoresList([])
      this.searchPrestador = ''
      this.itemAgendaGarantiaMinima = {}
    } else {
      const prestador = this.itemAgendaGarantiaMinima.prestadorNome
      if (prestador) {
        this.loadingPrestadorFilter = true
        await this.prestadoresDebounced(prestador)
      }

      if (this.agendaGarantiaStore.itemAgendaGarantiaMinima.profissionalExecutanteId) {
        let obj = {
          userId: this.itemAgendaGarantiaMinima.profissionalExecutanteId,
          nome: this.itemAgendaGarantiaMinima.profissionalExecutanteNome,
        }
        this.profissionalExecutante = obj
        this.profissionalName = obj.nome
        this.agendaGarantiaStore.setPessoaProfissionalExecutanteList([obj])
      }
    }
  }

  @Watch('agendaGarantiaStore.itemAgendaGarantiaMinima.dataGarantia')
  onChangeDataGarantia(value) {
    if (value) {
      const date = new Date(value)
      if (date.toString() !== 'Invalid Date') {
        const [formattedDate] = date.toISOString().split('T')
        this.agendaGarantiaStore.itemAgendaGarantiaMinima.dataGarantia = formattedDate
      } else {
        console.log('Data inválida detectada, mantendo o valor original:', value)
      }
    }
  }

  @Watch('profissionaisList')
  onChangeProfissionaisList(value) {
    if(value) this.loadingProfissionalFilter = false
  }

  @Watch('prestadorList')
  onChangePrestadorList(value) {
    if(value) this.loadingPrestadorFilter = false
  }
}
